export default "__VITE_ASSET__23230e39__"